export default __webpack_public_path__ + "static/media/sus3.92e2197f.jpg";